(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["accordion-gallery"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (!root || root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      const items = [...root.querySelectorAll('.accordion-gallery__item')];
      if (!items.length) return;
      const activate = (item) => {
        items.forEach((entry) => entry.classList.toggle('is-active', entry === item));
      };
      const ratio = Number(root.style.getPropertyValue('--ag-expand'));
      if (ratio > 0 && ratio < 1 && items.length > 1) root.style.setProperty('--ag-active-grow', String((ratio * (items.length - 1)) / (1 - ratio)));
      const initial = Number(root.dataset.defaultIndex);
      activate(items[Math.min(Math.max(initial, 0), items.length - 1)]);
      items.forEach((item) => {
        if (root.dataset.trigger === 'hover') item.addEventListener('mouseenter', () => activate(item));
        item.addEventListener('focus', () => activate(item));
        item.addEventListener('click', (event) => {
          if (item.getAttribute('href') === '#') event.preventDefault();
          activate(item);
        });
        item.addEventListener('pointermove', (event) => {
          if (!item.classList.contains('is-active') || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
          const bounds = item.getBoundingClientRect();
          const x = (event.clientX - bounds.left) / bounds.width - .5;
          item.style.transform = `perspective(1000px) rotateY(${x * Number(root.style.getPropertyValue('--ag-tilt').replace('deg', ''))}deg)`;
          const image = item.querySelector('.accordion-gallery__image');
          if (image) image.style.objectPosition = `${50 - x * Number(root.dataset.parallax) * 20}% center`;
        });
        item.addEventListener('pointerleave', () => { item.style.transform = ''; });
      });
    };
    document.querySelectorAll('.accordion-gallery').forEach(init);
    document.addEventListener('shopify:section:load', (event) => init(event.target.querySelector('.accordion-gallery')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["account-entry"]) return;
  try {
    
  document.querySelectorAll('.lv-auth__form[data-login-url]').forEach((form) => {
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      const email = form.querySelector('input[type="email"]');
      const status = form.querySelector('.lv-auth__status');
      const button = form.querySelector('button[type="submit"]');
      if (!email || !email.reportValidity()) return;
      try {
        const destination = new URL(form.dataset.loginUrl, window.location.origin);
        destination.searchParams.set('login_hint', email.value.trim());
        button.disabled = true;
        button.textContent = 'Abriendo acceso…';
        window.location.assign(destination.toString());
      } catch (_) {
        status.hidden = false;
        status.textContent = 'No se pudo abrir el acceso. Vuelve a intentarlo.';
        button.disabled = false;
        button.textContent = 'Continuar con correo';
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
(() => {
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const init = () => {
    document.querySelectorAll('[data-lv-magnetic]').forEach((link) => {
      link.addEventListener('pointermove', (event) => {
        if (!finePointer.matches || reducedMotion.matches) return;
        const rect = link.getBoundingClientRect();
        const dx = event.clientX - rect.left - rect.width / 2;
        const dy = event.clientY - rect.top - rect.height / 2;
        const strength = Math.max(0, 1 - Math.hypot(dx, dy) / 100);
        link.style.transform = `translate3d(${(dx * .3 * strength).toFixed(2)}px, ${(dy * .3 * strength).toFixed(2)}px, 0)`;
      });
      link.addEventListener('pointerleave', () => { link.style.transform = ''; });
      link.addEventListener('blur', () => { link.style.transform = ''; });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.querySelectorAll('.bubble-menu__disclosure').forEach((menu) => {
    const toggle = menu.querySelector('summary');
    menu.addEventListener('toggle', () => toggle.setAttribute('aria-expanded', String(menu.open)));
    document.addEventListener('click', (event) => {
      if (menu.open && !menu.contains(event.target)) menu.open = false;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lunvelis-tools"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = (root) => {
    if (!root || root.dataset.lvtReady === 'true') return;
    root.dataset.lvtReady = 'true';

    const swap = root.querySelector('[data-lvt-swap]');
    if (swap) {
      const cards = [...swap.querySelectorAll('[data-lvt-card]')];
      const counter = swap.querySelector('[data-lvt-counter]');
      const pauseButton = swap.querySelector('[data-lvt-pause]');
      let index = 0;
      let paused = false;
      let hovering = false;
      let focusWithin = false;
      let visible = !('IntersectionObserver' in window);
      let timer;
      let observer;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const paint = () => {
        cards.forEach((card, i) => {
          const active = i === index;
          const distance = (i - index + cards.length) % cards.length;
          card.dataset.active = active ? 'true' : 'false';
          card.setAttribute('aria-current', active ? 'true' : 'false');
          card.tabIndex = active ? 0 : -1;
          card.inert = !active;
          card.style.zIndex = String(cards.length - distance + 2);
          card.style.transform = active ? 'translate(0, 0) rotate(0) scale(1)' : distance === 1 ? 'translate(14px, -8px) rotate(2deg) scale(.97)' : 'translate(27px, -16px) rotate(4deg) scale(.94)';
        });
        if (counter) counter.textContent = `${String(index + 1).padStart(2, '0')} / ${String(cards.length).padStart(2, '0')}`;
      };
      const move = (step) => { index = (index + step + cards.length) % cards.length; paint(); };
      const stop = () => window.clearInterval(timer);
      const start = () => {
        stop();
        if (reduceMotion || paused || hovering || focusWithin || !visible || document.hidden || cards.length < 2) return;
        timer = window.setInterval(() => move(1), 5000);
      };
      if ('IntersectionObserver' in window) {
        observer = new IntersectionObserver((entries) => {
          visible = entries.some((entry) => entry.isIntersecting);
          start();
        }, { threshold: 0.2 });
        observer.observe(swap);
      }
      swap.querySelector('[data-lvt-prev]')?.addEventListener('click', () => { move(-1); start(); });
      swap.querySelector('[data-lvt-next]')?.addEventListener('click', () => { move(1); start(); });
      pauseButton?.addEventListener('click', () => {
        paused = !paused;
        pauseButton.setAttribute('aria-pressed', String(paused));
        pauseButton.textContent = paused ? 'Reanudar rotación' : 'Pausar rotación';
        start();
      });
      swap.addEventListener('pointerenter', () => { hovering = true; stop(); });
      swap.addEventListener('pointerleave', () => { hovering = false; start(); });
      swap.addEventListener('focusin', () => { focusWithin = true; stop(); });
      swap.addEventListener('focusout', (event) => { if (!swap.contains(event.relatedTarget)) { focusWithin = false; start(); } });
      document.addEventListener('visibilitychange', start);
      const unload = (event) => {
        if (event.target.contains(root)) {
          stop();
          observer?.disconnect();
          document.removeEventListener('visibilitychange', start);
          document.removeEventListener('shopify:section:unload', unload);
        }
      };
      document.addEventListener('shopify:section:unload', unload);
      paint();
      start();
    }

    const feedback = root.querySelector('[data-lvt-feedback]');
    const secondaryFeedback = root.querySelector('[data-lvt-feedback-secondary]');
    const notes = root.querySelector('.lvt__notes');
    const toggleNotes = () => {
      if (!feedback || !notes) return;
      const open = feedback.getAttribute('aria-expanded') !== 'true';
      feedback.setAttribute('aria-expanded', String(open));
      notes.hidden = !open;
      if (secondaryFeedback) secondaryFeedback.textContent = open ? 'Cerrar notas de dirección' : 'Ver notas de dirección';
    };
    feedback?.addEventListener('click', toggleNotes);
    secondaryFeedback?.addEventListener('click', toggleNotes);

    root.querySelectorAll('input[name^="lvt-discipline-"]').forEach((radio) => {
      radio.addEventListener('change', () => {
        root.querySelectorAll('[data-lvt-item]').forEach((item) => {
          item.hidden = radio.value !== 'all' && item.dataset.lvtItem !== radio.value;
        });
      });
    });

    const stageCopy = root.querySelector('[data-lvt-stage-copy]');
    root.querySelectorAll('[data-lvt-stage]').forEach((button) => {
      button.addEventListener('click', () => {
        root.querySelectorAll('[data-lvt-stage]').forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
        if (stageCopy) stageCopy.textContent = button.dataset.copy || '';
      });
    });

    const call = root.querySelector('[data-lvt-call]');
    const runButton = root.querySelector('[data-lvt-run]');
    const runStatus = root.querySelector('[data-lvt-run-status]');
    let runTimer;
    runButton?.addEventListener('click', () => {
      window.clearTimeout(runTimer);
      call.dataset.state = 'running';
      runStatus.textContent = 'Procesando la demostración…';
      runButton.disabled = true;
      runButton.textContent = 'En curso';
      runTimer = window.setTimeout(() => {
        call.dataset.state = 'done';
        runStatus.textContent = 'Demostración completada';
        runButton.disabled = false;
        runButton.innerHTML = 'Repetir <span aria-hidden="true">↻</span>';
      }, 2400);
    });

    const slide = root.querySelector('[data-lvt-slide]');
    const fill = root.querySelector('[data-lvt-slide-fill]');
    const fallback = root.querySelector('.lvt__contact-fallback');
    if (slide && fallback) fallback.hidden = true;
    slide?.addEventListener('input', () => {
      const value = Number(slide.value);
      if (fill) fill.style.width = `${value}%`;
      slide.setAttribute('aria-valuetext', value >= 95 ? 'Formulario de proyecto listo' : `${value}%`);
      const thumb = root.querySelector('.lvt__slide-thumb');
      if (thumb) thumb.style.transform = `translateX(calc(${value}% - ${value * 0.48}px))`;
      if (value >= 95) {
        const form = document.getElementById('ProjectRegistrationForm');
        const destination = form || document.getElementById('ProjectRegistrationName');
        destination?.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
        const firstField = form?.querySelector('input:not([type="hidden"]), textarea, select');
        firstField?.focus({ preventScroll: true });
        slide.value = '0';
        if (fill) fill.style.width = '0%';
        slide.setAttribute('aria-valuetext', 'Inicio');
        const thumb = root.querySelector('.lvt__slide-thumb');
        if (thumb) thumb.style.transform = 'translateX(0)';
      }
    });

    root.querySelectorAll('[data-lvt-specular]').forEach((button) => {
      button.addEventListener('pointermove', (event) => {
        const rect = button.getBoundingClientRect();
        button.style.setProperty('--lvt-shine', `${event.clientX - rect.left}px`);
      });
    });
  };

  const scan = (scope = document) => scope.querySelectorAll('[data-lvt]').forEach(init);
  scan();
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
